import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, ArrowLeft } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import SEO from "../components/SEO";

const PrivacyPolicy = () => {
  const { lPath } = useLanguage();
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-8">
      <SEO
        title="Privacy Policy | S.K. Woollens"
        description="Privacy Policy of S.K. Woollens. Learn how we handle and protect commercial partner data."
        keywords="privacy policy, S.K. Woollens privacy"
        canonicalUrl="https://skwoolens.trivanahospitality.com/en/privacy-policy"
      />
      <Link
        to={lPath("/")}
        className="inline-flex items-center gap-1.5 text-xs font-semibold text-wool-bronze hover:text-wool-bronze-dark transition"
      >
        <ArrowLeft className="w-3.5 h-3.5" />
        <span>Return to Home</span>
      </Link>

      <div className="bg-white border border-wool-border rounded-3xl p-8 sm:p-12 shadow-subtle space-y-6">
        <div className="space-y-2 border-b border-wool-border/60 pb-4">
          <div className="wool-badge">
            <ShieldCheck className="w-3.5 h-3.5 text-wool-bronze" />
            <span>Commercial Privacy</span>
          </div>
          <h1 className="text-2xl sm:text-3xl font-extrabold text-wool-charcoal font-display">
            Privacy Policy
          </h1>
          <p className="text-xs text-wool-muted">
            Last Updated: August 2026 | S.K. Woollens, Bikaner, Rajasthan, India
          </p>
        </div>

        <div className="space-y-4 text-xs sm:text-sm text-wool-slate leading-relaxed">
          <h3 className="text-base font-bold text-wool-charcoal">1. Information Collection</h3>
          <p>
            S.K. Woollens collects commercial business information provided voluntarily by yarn manufacturers, spinning mills, wool exporters, and brokers through our enquiry forms, email correspondences, WhatsApp messages, and direct telephone calls.
          </p>

          <h3 className="text-base font-bold text-wool-charcoal">2. Use of Information</h3>
          <p>
            Business data—including company names, technical wool specifications, required micron/yield parameters, and contact phone numbers—is utilized solely to evaluate raw wool availability, prepare quotations, coordinate commercial contracts, and build long-term B2B supply relationships.
          </p>

          <h3 className="text-base font-bold text-wool-charcoal">3. Commercial Confidentiality</h3>
          <p>
            We treat technical specifications, pricing discussions, test reports, and supplier clip details with strict commercial confidentiality. We do not sell, rent, or trade your corporate information to third-party marketing entities.
          </p>

          <h3 className="text-base font-bold text-wool-charcoal">4. Direct Contact Desk</h3>
          <p>
            For any privacy inquiries regarding our B2B data practices, please contact our desk at <a href="mailto:NIKHILBANTH783@GMAIL.COM" className="text-wool-bronze underline">NIKHILBANTH783@GMAIL.COM</a> or call +91 7014581250.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
